// Block Party Games — minimal JS

// ============ Toast helper ============
window.bpmToast = function (msg, opts) {
  opts = opts || {};
  var t = document.createElement('div');
  t.className = 'bpm-toast bpm-toast--' + (opts.type || 'info');
  t.textContent = msg;
  document.body.appendChild(t);
  // force reflow then add visible class for animation
  // eslint-disable-next-line no-unused-expressions
  t.offsetWidth;
  t.classList.add('is-visible');
  setTimeout(function () {
    t.classList.remove('is-visible');
    setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 350);
  }, opts.duration || 2200);
};

// ============ AJAX cart helpers ============
window.bpmFetchCart = function () {
  return fetch('/cart.js', {
    headers: { Accept: 'application/json' },
    credentials: 'same-origin',
    cache: 'no-store'
  }).then(function (r) { return r.json(); });
};

// ============ Cart drawer ============
window.bpmFormatMoney = function (cents) {
  // Cart.js returns prices in cents. Format as $X.XX. Locale-agnostic but
  // matches how the rest of the theme displays money (USD).
  if (typeof cents !== 'number') return '';
  return '$' + (cents / 100).toFixed(2);
};

window.bpmRenderCartDrawer = function (cart) {
  var drawer = document.querySelector('[data-bpm-cart-drawer]');
  if (!drawer) return;
  var loading = drawer.querySelector('[data-bpm-cart-drawer-loading]');
  var itemsList = drawer.querySelector('[data-bpm-cart-drawer-items]');
  var emptyState = drawer.querySelector('[data-bpm-cart-drawer-empty]');
  var foot = drawer.querySelector('[data-bpm-cart-drawer-foot]');
  var subtotalEl = drawer.querySelector('[data-bpm-cart-drawer-subtotal]');
  var tpl = document.getElementById('bpm-cart-drawer-item-tpl');

  if (loading) loading.hidden = true;

  if (!cart || !cart.items || cart.items.length === 0) {
    if (itemsList) itemsList.hidden = true;
    if (emptyState) emptyState.hidden = false;
    if (foot) foot.hidden = true;
    return;
  }

  if (emptyState) emptyState.hidden = true;
  if (itemsList) {
    itemsList.hidden = false;
    itemsList.innerHTML = '';
    cart.items.forEach(function (item) {
      var li;
      if (tpl && tpl.content && tpl.content.firstElementChild) {
        li = tpl.content.firstElementChild.cloneNode(true);
      } else {
        // Defensive fallback
        li = document.createElement('li');
        li.className = 'bpm-cart-drawer__item';
      }

      // Stash the line item key on the element so qty/remove buttons know which line to mutate
      li.setAttribute('data-bpm-key', item.key);
      li.setAttribute('data-bpm-qty', item.quantity);

      var hrefs = li.querySelectorAll('[data-href]');
      hrefs.forEach(function (a) { if (a.tagName === 'A') a.href = item.url; });
      var img = li.querySelector('[data-img]');
      if (img) {
        if (item.image) {
          img.src = item.image.replace(/(\.[^.]+)$/, '_120x$1');
          img.alt = item.product_title || '';
        } else {
          img.style.display = 'none';
        }
      }
      var titleEl = li.querySelector('[data-title]');
      if (titleEl) titleEl.textContent = item.product_title || item.title || '';
      var variantEl = li.querySelector('[data-variant]');
      if (variantEl) {
        if (item.variant_title && item.variant_title !== 'Default Title' && item.variant_title !== 'Default') {
          variantEl.textContent = item.variant_title;
        } else {
          variantEl.style.display = 'none';
        }
      }
      var qtyEl = li.querySelector('[data-qty]');
      if (qtyEl) qtyEl.textContent = item.quantity;
      var priceEl = li.querySelector('[data-price]');
      if (priceEl) priceEl.textContent = window.bpmFormatMoney(item.final_line_price || (item.price * item.quantity));

      // Disable the "−" button when qty is 1 (next click would go to 0; remove button handles that)
      var decBtn = li.querySelector('[data-bpm-dec]');
      if (decBtn && item.quantity <= 1) decBtn.setAttribute('disabled', 'disabled');

      itemsList.appendChild(li);
    });
  }
  if (subtotalEl) subtotalEl.textContent = window.bpmFormatMoney(cart.items_subtotal_price || cart.total_price || 0);
  if (foot) foot.hidden = false;
};

// Change a single line item's quantity (or remove it by passing 0)
window.bpmChangeCartLine = function (key, newQty) {
  var url = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/change.js';
  return fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: key, quantity: newQty })
  })
  .then(function (r) { return r.json(); })
  .then(function (cart) {
    window.bpmRenderCartDrawer(cart);
    // Refresh header cart count if present
    var countEls = document.querySelectorAll('[data-bpm-cart-count]');
    if (cart && typeof cart.item_count === 'number') {
      countEls.forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
    }
    return cart;
  })
  .catch(function () { /* swallow */ });
};

// Wire up qty +/- and remove buttons via event delegation on the items list
(function bindCartDrawerControls(){
  var drawer = document.querySelector('[data-bpm-cart-drawer]');
  if (!drawer) return;
  var itemsList = drawer.querySelector('[data-bpm-cart-drawer-items]');
  if (!itemsList) return;
  if (itemsList.dataset.bpmControlsBound) return;
  itemsList.dataset.bpmControlsBound = '1';

  itemsList.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bpm-dec], [data-bpm-inc], [data-bpm-remove]');
    if (!btn) return;
    var li = btn.closest('[data-bpm-line-item]');
    if (!li) return;
    var key = li.getAttribute('data-bpm-key');
    var currentQty = parseInt(li.getAttribute('data-bpm-qty'), 10) || 1;
    if (!key) return;

    var newQty = currentQty;
    if (btn.hasAttribute('data-bpm-dec')) newQty = Math.max(1, currentQty - 1);
    else if (btn.hasAttribute('data-bpm-inc')) newQty = currentQty + 1;
    else if (btn.hasAttribute('data-bpm-remove')) newQty = 0;

    if (newQty === currentQty) return; // no change (e.g. dec hit when already at 1)

    li.classList.add('is-updating');
    window.bpmChangeCartLine(key, newQty);
  });
})();

window.bpmOpenCartDrawer = function (opts) {
  opts = opts || {};
  var drawer = document.querySelector('[data-bpm-cart-drawer]');
  if (!drawer) return;
  var eyebrow = drawer.querySelector('[data-bpm-cart-drawer-eyebrow]');
  if (eyebrow) eyebrow.textContent = opts.justAdded ? 'Added to cart' : 'Your bag';

  // Show loading state immediately so the drawer feels instant
  var loading = drawer.querySelector('[data-bpm-cart-drawer-loading]');
  var itemsList = drawer.querySelector('[data-bpm-cart-drawer-items]');
  var emptyState = drawer.querySelector('[data-bpm-cart-drawer-empty]');
  var foot = drawer.querySelector('[data-bpm-cart-drawer-foot]');
  if (loading) loading.hidden = false;
  if (itemsList) itemsList.hidden = true;
  if (emptyState) emptyState.hidden = true;
  if (foot) foot.hidden = true;

  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  document.documentElement.style.overflow = 'hidden';
  // Move focus to the panel for a11y
  var panel = drawer.querySelector('.bpm-cart-drawer__panel');
  if (panel) setTimeout(function () { try { panel.focus(); } catch (e) {} }, 50);

  return window.bpmFetchCart().then(function (cart) {
    window.bpmRenderCartDrawer(cart);
    if (cart && typeof cart.item_count === 'number') {
      window.bpmUpdateCartCount(cart.item_count);
    }
  }).catch(function () {
    if (loading) loading.textContent = 'Could not load your cart.';
  });
};

window.bpmCloseCartDrawer = function () {
  var drawer = document.querySelector('[data-bpm-cart-drawer]');
  if (!drawer) return;
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.documentElement.style.overflow = '';
};

window.bpmUpdateCartCount = function (count) {
  document.querySelectorAll('[data-bpm-cart-count]').forEach(function (el) {
    el.textContent = '(' + count + ')';
  });
};

window.bpmAddToCart = function (data) {
  // data: FormData OR object
  var body;
  if (data instanceof FormData) {
    body = data;
  } else {
    body = new FormData();
    Object.keys(data).forEach(function (k) { body.append(k, data[k]); });
  }
  return fetch('/cart/add.js', {
    method: 'POST',
    body: body,
    credentials: 'same-origin',
    headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
  }).then(function (r) {
    return r.json().then(function (j) { return { ok: r.ok, status: r.status, body: j }; });
  });
};

document.addEventListener('DOMContentLoaded', function () {
  // Cart quantity update via Shopify AJAX (qty buttons)
  document.querySelectorAll('[data-bpm-qty]').forEach(function (group) {
    var input = group.querySelector('input[type="number"]');
    var minus = group.querySelector('[data-bpm-qty-minus]');
    var plus  = group.querySelector('[data-bpm-qty-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (plus) plus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // Cart line item qty change → submit form
  document.querySelectorAll('form[action="/cart"] input[name^="updates"]').forEach(function (input) {
    input.addEventListener('change', function () {
      input.closest('form').submit();
    });
  });

  // Marquee — clone for seamless loop
  document.querySelectorAll('.bpm-marquee__track').forEach(function (track) {
    if (track.children.length === 1) {
      var clone = track.firstElementChild.cloneNode(true);
      track.appendChild(clone);
    }
  });

  // PDP gallery thumbs
  document.querySelectorAll('[data-bpm-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.dataset.bpmThumb;
      var main = document.querySelector('[data-bpm-gallery-main]');
      if (main && src) {
        main.innerHTML = '<img src="' + src + '" alt="">';
      }
    });
  });

  // PDP variant select → update Add to cart button text + price + sticky ATC
  document.querySelectorAll('[data-bpm-variant-select]').forEach(function (select) {
    var form = select.closest('form');
    if (!form) return;
    var btn = form.querySelector('[data-bpm-add-to-cart]');

    // Sticky ATC sync targets
    var stickyId    = document.querySelector('[data-bpm-sticky-id]');
    var stickyPrice = document.querySelector('[data-bpm-sticky-price]');
    var stickyBtn   = document.querySelector('[data-bpm-sticky-btn]');
    var currentPrice = document.querySelector('[data-bpm-current-price]');

    function update() {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      var price = opt.getAttribute('data-price') || '';
      var available = opt.getAttribute('data-available') === 'true';
      var variantId = opt.value;

      // Main ATC button text
      if (btn) {
        var labelAdd  = btn.getAttribute('data-label-add')     || 'Add to cart';
        var labelSold = btn.getAttribute('data-label-soldout') || 'Sold out';
        if (available) {
          btn.disabled = false;
          btn.textContent = labelAdd + (price ? ' — ' + price : '');
        } else {
          btn.disabled = true;
          btn.textContent = labelSold;
        }
      }

      // Inline current price (if rendered separately)
      if (currentPrice && price) currentPrice.textContent = price;

      // Sticky ATC sync
      if (stickyId)    stickyId.value = variantId;
      if (stickyPrice && price) stickyPrice.textContent = price;
      if (stickyBtn) {
        if (available) {
          stickyBtn.disabled = false;
          stickyBtn.textContent = 'Add to cart';
        } else {
          stickyBtn.disabled = true;
          stickyBtn.textContent = 'Sold out';
        }
      }
    }

    select.addEventListener('change', update);
  });

  // ============ Wire any cart-add form for AJAX submit ============
  function wireCartForm(form) {
    if (!form || form.dataset.bpmWired === '1') return;
    form.dataset.bpmWired = '1';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"], [data-bpm-add-to-cart], [data-bpm-sticky-btn], [data-bpm-grid-btn]');
      var origText;
      if (btn) {
        origText = btn.textContent;
        btn.disabled = true;
        btn.classList.add('is-loading');
        btn.textContent = 'Adding…';
      }
      var idInput = form.querySelector('[name="id"]');
      var variantId = idInput ? idInput.value : null;
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      console.log('[bpm] Add to cart — variant:', variantId, 'qty:', qty);

      var inEditor = (typeof window.Shopify !== 'undefined' && window.Shopify.designMode);

      function restoreBtn() {
        if (!btn) return;
        btn.disabled = false;
        btn.classList.remove('is-loading');
        btn.textContent = origText;
      }

      // Capture cart count BEFORE so we can verify it actually went up.
      window.bpmFetchCart().then(function (cartBefore) {
        var beforeCount = (cartBefore && typeof cartBefore.item_count === 'number') ? cartBefore.item_count : 0;
        console.log('[bpm] Cart count before:', beforeCount);

        var fd = new FormData(form);
        return window.bpmAddToCart(fd).then(function (res) {
          console.log('[bpm] /cart/add.js response:', res);
          if (!res.ok) {
            var msg = (res.body && (res.body.description || res.body.message)) || 'Could not add to cart.';
            window.bpmToast(msg, { type: 'error', duration: 4500 });
            restoreBtn();
            return;
          }

          // Success status — but verify the cart actually updated.
          return window.bpmFetchCart().then(function (cartAfter) {
            var afterCount = (cartAfter && typeof cartAfter.item_count === 'number') ? cartAfter.item_count : 0;
            console.log('[bpm] Cart count after:', afterCount);

            if (afterCount <= beforeCount) {
              // Cart didn't actually update — almost always a Shopify theme-editor
              // sandbox issue. Tell the user clearly.
              var note = inEditor
                ? 'Cart didn\'t update inside the theme editor. This is a Shopify editor preview limitation — please test Add to cart on your live storefront (cptimegame.com), not in the editor.'
                : 'Cart didn\'t update. Try refreshing — if it keeps happening, third-party cookies may be blocked.';
              window.bpmToast(note, { type: 'error', duration: 6000 });
              restoreBtn();
              return;
            }

            // Real success — count went up. Open the cart drawer so the user
            // can choose to keep shopping, view the full cart, or check out.
            window.bpmUpdateCartCount(afterCount);
            if (btn) {
              btn.classList.remove('is-loading');
              btn.textContent = 'Added ✓';
            }
            // Render straight from the cart we just fetched — avoids a second roundtrip.
            window.bpmOpenCartDrawer({ justAdded: true });
            // Restore the button shortly so they can keep adding without a stuck state.
            setTimeout(function () {
              if (btn) {
                btn.disabled = false;
                btn.textContent = origText;
              }
            }, 1500);
          });
        });
      }).catch(function (err) {
        console.error('[bpm] Cart add error:', err);
        window.bpmToast('Network error. Please try again.', { type: 'error', duration: 4000 });
        restoreBtn();
      });
    });
  }

  // PDP main form, sticky form, and any grid ATC forms
  document.querySelectorAll(
    '.bpm-cart-add-form, [data-bpm-sticky-form], [data-bpm-grid-form]'
  ).forEach(wireCartForm);

  // ============ Mobile drawer close button ============
  document.querySelectorAll('[data-bpm-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var drawer = document.querySelector('[data-bpm-drawer]');
      var burger = document.querySelector('[data-bpm-burger]');
      if (!drawer) return;
      drawer.setAttribute('hidden', '');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
    });
  });

  // ============ Cart drawer close handlers ============
  document.querySelectorAll('[data-bpm-cart-drawer-close]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      window.bpmCloseCartDrawer();
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.querySelector('[data-bpm-cart-drawer].is-open');
    if (d) window.bpmCloseCartDrawer();
  });

  // Header cart link → open drawer (keep right-click / new tab working)
  document.querySelectorAll('a[href$="/cart"], a[href$="/cart/"]').forEach(function (link) {
    // Only intercept the header cart link (and similar) — leave the
    // "View full cart" button inside the drawer alone (it lives inside
    // [data-bpm-cart-drawer]).
    if (link.closest('[data-bpm-cart-drawer]')) return;
    link.addEventListener('click', function (e) {
      // Allow modifier-clicks to behave normally (open in new tab, etc.)
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      window.bpmOpenCartDrawer({ justAdded: false });
    });
  });

  // ============ Back link ============
  document.querySelectorAll('[data-bpm-back]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (window.history.length > 1) {
        e.preventDefault();
        window.history.back();
      }
      // else: let the href fallback (default home) take over
    });
  });

  // Sticky ATC — show after main ATC button scrolls out of view
  (function () {
    var sticky = document.querySelector('[data-bpm-sticky-atc]');
    var mainBtn = document.querySelector('[data-bpm-add-to-cart]');
    if (!sticky || !mainBtn) return;

    function setVisible(visible) {
      if (visible) {
        sticky.classList.add('is-visible');
        sticky.setAttribute('aria-hidden', 'false');
      } else {
        sticky.classList.remove('is-visible');
        sticky.setAttribute('aria-hidden', 'true');
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Show sticky when the main ATC has scrolled out of view
          setVisible(!entry.isIntersecting);
        });
      }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });
      io.observe(mainBtn);
    } else {
      // Fallback: simple scroll handler
      window.addEventListener('scroll', function () {
        var rect = mainBtn.getBoundingClientRect();
        setVisible(rect.bottom < 0 || rect.top > window.innerHeight);
      }, { passive: true });
    }
  })();
});
